module.exports = import("https://esm.sh/@tiptap/extension-text-style@2.4.0");;